import MarketingChannelRoutes from "@/routes/Customer/MarketingChannel/MarketingChannelRoutes";
import TagRoutes from "@/routes/Customer/Tag/TagRoutes";
import ManualAdditionRoutes from "@/routes/Customer/TravelMiles/ManualAdditions/ManualAdditionRoutes.js";
import PresentRoutes from "@/routes/Present/PresentRoutes";
import FaqItemRoutes from "@/routes/FaqItem/FaqItemRoutes";
import CurrencyRoutes from "@/routes/Currency/CurrencyRoutes";
import CustomerRoutes from "@/routes/Customer/CustomerRoutes";
import PageViewRoutes from "@/routes/PageView/PageViewRoutes";
import UserRoutes from "@/routes/User/UserRoutes";
import DialogueRoutes from "@/routes/Customer/Dialogue/DialogueRoutes";
import MagazineRoutes from "@/routes/Magazine/MagazineRoutes";
import ComplaintRoutes from "@/routes/Dossier/Complaint/ComplaintRoutes";
import SurveyRoutes from "@/routes/Dossier/Survey/SurveyRoutes";
import MarginRoutes from "@/routes/Margin/MarginRoutes";
import OnlineMagazineRoutes from "@/routes/OnlineMagazine/OnlineMagazineRoutes";
import ContactRequestRoutes from "@/routes/ContactRequest/ContactRequestRoutes";
import DownloadRoutes from "@/routes/Download/DownloadRoutes";
import CountryRoutes from "@/routes/Country/CountryRoutes";
import CityRoutes from "@/routes/City/CityRoutes";
import AirportRoutes from "@/routes/Airport/AirportRoutes";
import AiPromptRoutes from "@/routes/AiPrompt/AiPromptRoutes.js";
import PhoneSmsRoutes from "@/routes/PhoneSms/PhoneSmsRoutes";
import ProposalRoutes from "@/routes/Proposal/ProposalRoutes";
import DossierRoutes from "@/routes/Dossier/DossierRoutes";
import TravellerRoutes from "@/routes/Dossier/Traveller/TravellerRoutes";
import GroupRoutes from "@/routes/User/Group/GroupRoutes";
import InternalHelpTextRoutes from "@/routes/InternalHelpText/InternalHelpTextRoutes";
import RevenueGroupRoutes from "@/routes/RevenueGroup/RevenueGroupRoutes";
import RoleRoutes from "@/routes/User/Role/RoleRoutes";
import StatisticsRoutes from "@/routes/Statistics/StatisticsRoutes";
import NotificationRoutes from "@/routes/User/Notification/NotificationRoutes";
import DashboardRoutes from "@/routes/Dashboard/DashboardRoutes";
import TaskRoutes from "@/routes/Task/TaskRoutes";
import MessageRoutes from "@/routes/Message/MessageRoutes";
import TicketRoutes from "@/routes/Ticket/TicketRoutes";
import PaymentTermRoutes from "@/routes/Proposal/PaymentTerm/PaymentTermRoutes";
import SaleTargetRoutes from "@/routes/User/SaleTarget/SaleTargetRoutes";
import MinimumMarginRoutes from "@/routes/MinimumMargin/MinimumMarginRoutes";
import TargetRoutes from "@/routes/Airline/Target/TargetRoutes";
import RemarksRoutes from "@/routes/Proposal/Invoice/Remarks/RemarksRoutes";
import SettingRoutes from "@/routes/Setting/SettingRoutes";
import ActionRoutes from "@/routes/Task/Action/ActionRoutes";
import WebsiteRedirectRoutes from "@/routes/WebsiteRedirect/WebsiteRedirectRoutes";
import MediaLibraryTagRoutes from "@/routes/MediaLibrary/Tag/MediaLibraryTagRoutes";
import WebsiteRouteRoutes from "@/routes/WebsiteRoute/WebsiteRouteRoutes";
import WebsiteCacheRoutes from "@/routes/WebsiteCache/WebsiteCacheRoutes";
import WebsiteCategoryRoutes from "@/routes/WebsiteCategory/WebsiteCategoryRoutes";
import LegalContentRoutes from "@/routes/LegalContent/LegalContentRoutes";
import WebsitePreviewRoutes from "@/routes/WebsitePage/Preview/PreviewRoutes";
import WebsiteCustomerReviewRoutes from "@/routes/WebsiteCustomerReview/WebsiteCustomerReviewRoutes";
import ExpertiseCountryRoutes from "@/routes/User/ExpertiseCountry/ExpertiseCountryRoutes";
import CountryProficiencyRoutes from "@/routes/User/CountryProficiency/CountryProficiencyRoutes";
import WebsiteProductTagRoutes from "@/routes/WebsiteProduct/Tag/TagRoutes";
import WebsiteProductTagTypeRoutes from "@/routes/WebsiteProduct/Tag/Type/TypeRoutes";
import WebsiteCountryRoutes from "@/routes/Country/Website/WebsiteCountryRoutes";
import WebsiteFilterPageRoutes from "@/routes/WebsiteFilterPage/WebsiteFilterPageRoutes";
import WebsiteBlogRoutes from "@/routes/WebsiteBlog/WebsiteBlogRoutes";
import TopicRoutes from "@/routes/WebsiteBlog/Topic/TopicRoutes";
import WebsiteWidgetRoutes from "@/routes/WebsiteWidget/WebsiteWidgetRoutes";
import WebsitePageRoutes from "@/routes/WebsitePage/WebsitePageRoutes";
import AgentRoutes from "@/routes/Agent/AgentRoutes";
import WebsiteNavigationRoutes from "@/routes/WebsiteNavigation/WebsiteNavigationRoutes";
import FlightRoutes from "@/routes/Flight/FlightRoutes";
import AirlineRoutes from "@/routes/Airline/AirlineRoutes";
import RegionRoutes from "@/routes/Region/RegionRoutes";
import ClassificationRoutes from "@/routes/Flight/Classification/ClassificationRoutes";
import AllotmentRoutes from "@/routes/Airline/Allotment/AllotmentRoutes";
import ProductPackageRoutes from "@/routes/ProductPackage/ProductPackageRoutes";
import MediaLibraryRoutes from "@/routes/MediaLibrary/MediaLibraryRoutes";
import InventoryRoutes from "@/routes/Agent/Inventory/InventoryRoutes";
import DefaultMarginRoutes from "@/routes/Agent/DefaultMargin/DefaultMarginRoutes";
import BackofficeScrumboardRoutes from "@/routes/BackofficeScrumboard/BackofficeScrumboardRoutes";
import PlatinumRouteRoutes from "@/routes/PlatinumRoute/PlatinumRouteRoutes";
import PlatinumRedirectRoutes from "@/routes/PlatinumRedirect/PlatinumRedirectRoutes";
import PlatinumPageRoutes from "@/routes/PlatinumPage/PlatinumPageRoutes";
import PlatinumCacheRoutes from "@/routes/PlatinumCache/PlatinumCacheRoutes";
import PlatinumWidgetRoutes from "@/routes/PlatinumWidget/PlatinumWidgetRoutes";
import PlatinumHotelRoutes from "@/routes/PlatinumHotel/PlatinumHotelRoutes";
import SalesScrumboardRoutes from "@/routes/SalesScrumboard/SalesScrumboardRoutes";
import PlatinumPreviewRoutes from "@/routes/PlatinumPage/Preview/PreviewRoutes";
import PlatinumNavigationRoutes from "@/routes/PlatinumNavigation/PlatinumNavigationRoutes";
import PlatinumExperienceRoutes from "@/routes/PlatinumExperience/PlatinumExperienceRoutes";
import PlatinumFooterLinkRoutes from "@/routes/PlatinumFooterLink/PlatinumFooterLinkRoutes";
import CampaignRoutes from "@/routes/Campaign/CampaignRoutes";
import PlaceholderRoutes from "@/routes/Proposal/Presentation/Placeholder/PlaceholderRoutes";
import AgentMessageRoutes from "@/routes/AgentMessage/AgentMessageRoutes";
import HighlightRoutes from "@/routes/WebsiteHighlight/HighlightRoutes.js";
import PriceExtensionRoutes from "@/routes/ProductPackage/PriceExtension/PriceExtensionRoutes.js";
import CountryPackageSizeRoutes from "@/routes/Hubby/CountryPackageSize/CountryPackageSizeRoutes.js";
import NoticeRoutes from "@/routes/Country/Notice/NoticeRoutes.js";
import WorkLocationRoutes from "@/routes/User/WorkLocation/WorkLocationRoutes.js";
import JourneyRoutes from "@/routes/User/Journey/JourneyRoutes.js";
import PrefillRoutes from "@/routes/Proposal/Presentation/Day/Prefill/PrefillRoutes.js";
import WebsiteCatalogRankingRoutes from "@/routes/WebsiteCatalogRanking/WebsiteCatalogRankingRoutes.js";
import WebsiteNewsPageRoutes from "./WebsiteNewsPage/WebsiteNewsPageRoutes";
import WebsiteFooterRoutes from "@/routes/WebsiteFooter/WebsiteFooterRoutes.js";

export default [
    ...MarketingChannelRoutes,
    ...TagRoutes,
    ...ManualAdditionRoutes,
    ...PresentRoutes,
    ...FaqItemRoutes,
    ...CurrencyRoutes,
    ...DialogueRoutes,
    ...CustomerRoutes,
    ...PageViewRoutes,
    ...UserRoutes,
    ...MarginRoutes,
    ...MagazineRoutes,
    ...ComplaintRoutes,
    ...SurveyRoutes,
    ...OnlineMagazineRoutes,
    ...ContactRequestRoutes,
    ...CityRoutes,
    ...AirportRoutes,
    ...DownloadRoutes,
    ...SalesScrumboardRoutes,
    ...BackofficeScrumboardRoutes,
    ...CountryRoutes,
    ...HighlightRoutes,
    ...ProposalRoutes,
    ...DossierRoutes,
    ...TravellerRoutes,
    ...PhoneSmsRoutes,
    ...GroupRoutes,
    ...RevenueGroupRoutes,
    ...InternalHelpTextRoutes,
    ...StatisticsRoutes,
    ...RoleRoutes,
    ...NotificationRoutes,
    ...DashboardRoutes,
    ...TaskRoutes,
    ...MessageRoutes,
    ...TicketRoutes,
    ...PaymentTermRoutes,
    ...SaleTargetRoutes,
    ...MinimumMarginRoutes,
    ...TargetRoutes,
    ...RemarksRoutes,
    ...SettingRoutes,
    ...ActionRoutes,
    ...WebsiteRedirectRoutes,
    ...MediaLibraryTagRoutes,
    ...WebsiteRouteRoutes,
    ...WebsiteCacheRoutes,
    ...LegalContentRoutes,
    ...WebsitePreviewRoutes,
    ...WebsiteCustomerReviewRoutes,
    ...ExpertiseCountryRoutes,
    ...CountryProficiencyRoutes,
    ...WebsiteProductTagRoutes,
    ...WebsiteProductTagTypeRoutes,
    ...WebsiteCategoryRoutes,
    ...WebsiteCountryRoutes,
    ...WebsiteFilterPageRoutes,
    ...WebsiteBlogRoutes,
    ...TopicRoutes,
    ...WebsiteWidgetRoutes,
    ...WebsitePageRoutes,
    ...InventoryRoutes,
    ...DefaultMarginRoutes,
    ...AgentRoutes,
    ...AgentMessageRoutes,
    ...WebsiteNavigationRoutes,
    ...RegionRoutes,
    ...ClassificationRoutes,
    ...FlightRoutes,
    ...AirlineRoutes,
    ...PriceExtensionRoutes,
    ...ProductPackageRoutes,
    ...AllotmentRoutes,
    ...MediaLibraryRoutes,
    ...PlatinumPreviewRoutes,
    ...PlatinumRouteRoutes,
    ...PlatinumRedirectRoutes,
    ...PlatinumPageRoutes,
    ...PlatinumCacheRoutes,
    ...PlatinumWidgetRoutes,
    ...PlatinumHotelRoutes,
    ...PlatinumExperienceRoutes,
    ...CampaignRoutes,
    ...PlatinumNavigationRoutes,
    ...PlatinumFooterLinkRoutes,
    ...PlaceholderRoutes,
    ...AiPromptRoutes,
    ...CountryPackageSizeRoutes,
    ...NoticeRoutes,
    ...WorkLocationRoutes,
    ...JourneyRoutes,
    ...PrefillRoutes,
    ...WebsiteCatalogRankingRoutes,
    ...WebsiteNewsPageRoutes,
    ...WebsiteFooterRoutes,
    {
        path: "*",
        props: true,
        component: () => import("@/views/NotFound.vue"),
    },
];
